/* 
 * 系统登录模块
 */

// 前端登录 参数username password  post
export const login = '/admin/login'

/** 获取用户的用户信息等 */
export const info = '/admin/info'

// 登出
export const logout = '/doLogout'

// 获取验证码
export const sendSms = '/admin/sendSms'

// 用户申请
export const userApply = '/admin/apply'



// WEBPACK FOOTER //
// ./src/http/moudules/login.js